import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

function fmtAbs(v: number | string): string {
  return '$' + Math.abs(Number(v) || 0).toLocaleString('en-AU', { maximumFractionDigits: 0 });
}

export interface SummaryCardProps {
  label: string;
  value: number | string;
  color: string | null;
  isLoading: boolean;
}

export default function SummaryCard({ label, value, color, isLoading }: SummaryCardProps) {
  const negative = Number(value) < 0;
  const resolvedColor = color ?? (negative ? '#ef5350' : '#6ccf7d');
  return (
    <Paper
      variant="outlined"
      sx={{
        flex: { xs: '1 1 100px', sm: '1 1 140px' },
        p: { xs: '10px 14px', sm: '14px 18px' },
        borderColor: resolvedColor + '55',
        background: resolvedColor + '12',
        borderRadius: 2,
        minWidth: 0,
      }}
    >
      <Typography
        variant="caption"
        sx={{ textTransform: 'uppercase', letterSpacing: '.6px', fontWeight: 600, color: resolvedColor, display: 'block', mb: 0.5 }}
      >
        {label}
      </Typography>
      {isLoading ? (
        <Skeleton variant="text" width={80} height={32} />
      ) : (
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, fontSize: { xs: '1.05rem', sm: '1.2rem' }, color: negative ? '#ef5350' : 'text.primary', lineHeight: 1.2 }}
        >
          {negative ? '-' : ''}{fmtAbs(value)}
        </Typography>
      )}
    </Paper>
  );
}
